module.exports = __webpack_public_path__ + "img/top-10-product.31518a1a.webp";